import Axios from 'axios'
import config from '@/config/config.js'
// const baseUrl = 'http://192.168.119.122:8081'
const baseUrl = config.apiDomain.ALI + '/ext/core-util/front-end/api/log/insert/'
const scriptUrl = baseUrl + 'javascript'
const vueUrl = baseUrl + 'vue'
const httpErrorStatusUrl = baseUrl + 'httpErrorStatus'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  submitScript (body, cb) {
    Axios.post(scriptUrl, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error('submitScript:' + error)
        cb(error.response)
      }
    )
  },

  submitVue (body, cb) {
    Axios.post(vueUrl, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error('submitVue: ' + JSON.stringify(error.response))
        cb(error.response)
      }
    )
  },

  submitHttpErrorStatus (body, cb) {
    Axios.post(httpErrorStatusUrl, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error('submitVue: ' + JSON.stringify(error.response))
        cb(error.response)
      }
    )
  }

}
